import { FC } from 'react';
import { useDispatch } from 'react-redux';

import { BaseModal } from 'wbs-components-lib';

import { VipTaskTypesEnum } from '@shared/constants';

import { useUpdateVipTaskMutation } from '@services';

import { AppDispatch, updateVipTasks } from '@store';

import { VipTaskFormValues, VipTaskForm } from '../../VipSettingsForms';

import { VipTaskEditModalProps } from './types';

export const VipTaskEditModal: FC<VipTaskEditModalProps> = ({ isOpened, handleClose, vipTask }) => {
  const { id, ...initialFormValues } = vipTask;

  const dispatch = useDispatch<AppDispatch>();

  const [updateVipTask, { isLoading: isUpdateInProgress }] = useUpdateVipTaskMutation();

  const handleUpdateBonus = async ({ link, promoCode, ymId, casinoName, ...values }: VipTaskFormValues) => {
    const { type } = values;

    const updatedVipTask = await updateVipTask({
      payload: {
        ...values,
        link: type === VipTaskTypesEnum.PARTNER ? link : undefined,
        promoCode: type === VipTaskTypesEnum.PARTNER ? promoCode : undefined,
        ymId: type === VipTaskTypesEnum.PARTNER ? ymId : undefined,
        casinoName: type === VipTaskTypesEnum.PARTNER ? casinoName : undefined,
      },
      vipTaskId: id,
    }).unwrap();

    dispatch(updateVipTasks(updatedVipTask));

    handleClose();
  };

  return (
    <BaseModal headerTitle="Edit VIP task" isOpened={isOpened} handleClose={handleClose} isFooterNeeded={false}>
      <VipTaskForm
        submitButtonCaption="Edit"
        initialValues={initialFormValues}
        isSubmitting={isUpdateInProgress}
        onSubmit={handleUpdateBonus}
      />
    </BaseModal>
  );
};
